import { render, staticRenderFns } from "./CatalogFiltersCheckbox.vue?vue&type=template&id=573aeac0&"
import script from "./CatalogFiltersCheckbox.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersCheckbox.js?vue&type=script&lang=js&"
import style0 from "./CatalogFiltersCheckbox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports